import { designTokens, commonStyles } from './designSystem';

export const modalStyles = {
  // 배경 오버레이
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: designTokens.spacing.lg
  },

  // 모달 컨테이너
  container: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.lg,
    border: `1px solid ${designTokens.colors.border}`,
    maxWidth: '90vw',
    maxHeight: '90vh',
    overflow: 'hidden',
    position: 'relative'
  },

  // 모달 헤더
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: designTokens.spacing.xxl,
    borderBottom: `1px solid ${designTokens.colors.borderLight}`,
    backgroundColor: designTokens.colors.background
  },

  title: {
    fontSize: '20px',
    fontWeight: '600',
    color: designTokens.colors.text.primary,
    margin: 0
  },

  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '18px',
    color: designTokens.colors.text.tertiary,
    cursor: 'pointer',
    padding: designTokens.spacing.sm,
    borderRadius: designTokens.borderRadius.md,
    transition: 'all 0.2s ease',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  // 모달 콘텐츠
  content: {
    padding: designTokens.spacing.xxl,
    maxHeight: 'calc(90vh - 120px)',
    overflowY: 'auto'
  },

  // 폼 필드
  field: {
    marginBottom: designTokens.spacing.lg
  },

  fieldFull: {
    marginBottom: designTokens.spacing.lg,
    gridColumn: '1 / -1'
  },

  label: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: designTokens.colors.text.secondary,
    marginBottom: designTokens.spacing.sm
  },

  input: {
    width: '100%',
    padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    color: designTokens.colors.text.primary,
    backgroundColor: designTokens.colors.surface,
    transition: 'border-color 0.2s ease'
  },

  inputDisabled: {
    backgroundColor: designTokens.colors.background,
    color: designTokens.colors.text.tertiary,
    cursor: 'not-allowed'
  },

  select: {
    width: '100%',
    padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    backgroundColor: designTokens.colors.surface,
    color: designTokens.colors.text.primary,
    cursor: 'pointer'
  },

  // 입력 그룹 (아이디 + 중복체크 버튼)
  inputGroup: {
    display: 'flex',
    gap: designTokens.spacing.md
  },

  inputInGroup: {
    flex: 1
  },

  checkButton: {
    padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
    backgroundColor: designTokens.colors.secondary,
    color: designTokens.colors.surface,
    border: 'none',
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    whiteSpace: 'nowrap'
  },

  // 상태 메시지
  statusMessage: {
    fontSize: '13px',
    fontWeight: '500',
    marginTop: designTokens.spacing.xs,
    padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
    borderRadius: designTokens.borderRadius.sm,
    opacity: 0,
    transform: 'translateY(-10px)',
    transition: 'all 0.3s ease'
  },

  statusMessageActive: {
    opacity: 1,
    transform: 'translateY(0)'
  },

  statusMessageSuccess: {
    color: designTokens.colors.status.valid,
    backgroundColor: '#dcfce7'
  },

  statusMessageError: {
    color: designTokens.colors.status.invalid,
    backgroundColor: '#fee2e2'
  },

  // 제출 버튼
  submitButton: {
    width: '100%',
    padding: `${designTokens.spacing.lg} ${designTokens.spacing.xxl}`,
    backgroundColor: designTokens.colors.primary,
    color: designTokens.colors.surface,
    border: 'none',
    borderRadius: designTokens.borderRadius.md,
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
    marginTop: designTokens.spacing.lg
  }
};

// 상세/등록 모달 공통 스타일 (PaymentModal, CouponDetailModal 등 플렉스 컬럼 레이아웃 모달)
export const detailModalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: designTokens.spacing.xxl
  },
  container: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.lg,
    width: '100%',
    maxWidth: '900px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
  },
  header: {
    padding: designTokens.spacing.xxl,
    borderBottom: `1px solid ${designTokens.colors.border}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: designTokens.colors.surface,
    borderRadius: `${designTokens.borderRadius.xl} ${designTokens.borderRadius.xl} 0 0`
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.md,
    fontSize: '20px',
    fontWeight: '600',
    color: designTokens.colors.text.primary,
    margin: 0
  },
  closeButton: {
    ...commonStyles.buttonBase,
    padding: designTokens.spacing.md,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    color: designTokens.colors.text.tertiary,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    border: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '36px',
    height: '36px'
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: designTokens.spacing.xxl
  },
  section: {
    ...commonStyles.card,
    padding: designTokens.spacing.xl,
    marginBottom: designTokens.spacing.xl
  },
  formField: {
    display: 'flex',
    flexDirection: 'column',
    gap: designTokens.spacing.sm
  },
  actionButtons: {
    display: 'flex',
    gap: designTokens.spacing.md,
    justifyContent: 'center',
    padding: designTokens.spacing.xl,
    borderTop: `1px solid ${designTokens.colors.border}`,
    backgroundColor: designTokens.colors.background
  },
  primaryButton: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.primary,
    color: designTokens.colors.surface,
    padding: `${designTokens.spacing.md} ${designTokens.spacing.xxl}`,
    fontSize: '14px',
    fontWeight: '600'
  },
  secondaryButton: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.surface,
    color: designTokens.colors.secondary,
    border: `1px solid ${designTokens.colors.border}`,
    padding: `${designTokens.spacing.md} ${designTokens.spacing.xxl}`,
    fontSize: '14px',
    fontWeight: '600'
  }
};
